<template>
  <v-container class='mb-10'>
    <v-row>
      <v-col cols="12" md="3" sm="6" xs="12">
        <searchable-select :value.sync="dataTableFilter.machine_id" :options="{ url: 'machine', label: 'Machine'}" :errorMessage="error.machine_id"/>
      </v-col>
      <v-col cols="12" md="3" sm="6" xs="12">
        <v-text-field
        v-model="dataTableFilter.from_date"
        :error-messages="error.from_date"
        type="date"
        label="From Date"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="6" xs="12">
        <v-text-field
        v-model="dataTableFilter.to_date"
        :error-messages="error.to_date"
        type="date"
        label="To Date"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="6" xs="12">
        <searchable-select :value.sync="dataTableFilter.project_id" :options="{ url: 'project', label: 'Project'}" :errorMessage="error.project_id"/>
      </v-col>
      <v-col cols="12" md="3" sm="6" xs="12">
        <searchable-select :value.sync="dataTableFilter.welding_procedure_id" :options="{ url: 'welding_procedure', label: 'WPS'}" :errorMessage="error.welding_procedure_id"/>
      </v-col>
      <v-col cols="12" md="3" sm="6" xs="12">
        <searchable-select :value.sync="dataTableFilter.welder_id" :options="{ url: 'welder', label: 'Welder'}" :errorMessage="error.welder_id"/>
      </v-col>
      <v-col cols="12" md="3" sm="6" xs="12">
        <v-text-field
        v-model="dataTableFilter.current"
        :error-messages="error.current"
        label="Current"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="6" xs="12">
        <v-text-field
        v-model="dataTableFilter.voltage"
        :error-messages="error.voltage"
        label="Voltage"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" sm="6" xs="12">
        <!-- <v-btn color="primary" class="mt-5" @click="generate" small v-if="!$vuetify.breakpoint.mdAndDown">Generate</v-btn>
        <v-btn color="primary" @click="generate" small block v-else>Generate</v-btn> -->
        <v-container v-if="!$vuetify.breakpoint.mdAndDown">
          <v-btn color="primary" class="mt-5" @click="generate" small>Generate</v-btn>&nbsp;
          <v-btn color="primary" class="mt-5" @click="exportData" small>Export</v-btn>
        </v-container>
        <v-container v-else>
          <v-btn color="primary" class="mt-5" @click="generate" small block>Generate</v-btn>
          <v-btn color="primary" class="mt-5" @click="exportData" small block>Export</v-btn>
        </v-container>
      </v-col>
    </v-row>
    <hr />
    <v-row>
     <v-data-table
       :headers="headers"
       :items="report"
       :options.sync="dataTableOptions"
       :server-items-length="totalTableDataCount"
       :footer-props="footerProps"
       class="col-md-12"
     ></v-data-table>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      error: {},
      report: [],
      loading: true,
      startRequest: false,
      interval: '',
      isGenerated: false,
      footerProps: { 'items-per-page-options': [10, 20, 50, 100, 200] },
      dataTableOptions: {
        groupBy: [],
        groupDesc: [],
        itemsPerPage: 10,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      dataTableFilter: {
        from_date: new Date().toISOString().substr(0, 10),
        to_date: new Date().toISOString().substr(0, 10)
      },
      totalTableDataCount: 0,
      headers: [
        { text: 'Time Stamp', value: 'date' },
        { text: 'Project No', value: 'project_name', align: 'center' },
        { text: 'WPS ID', value: 'welding_procedure_name', align: 'center' },
        { text: 'Welder ID', value: 'welder_name', align: 'center' },
        { text: 'Curent', value: 'current', align: 'center' },
        { text: 'Voltage', value: 'voltage', align: 'center' },
        { text: 'Feedspeed', value: 'feedspeed', align: 'center' },
        { text: 'Flowrate', value: 'flowrate', align: 'center' },
        { text: 'Travel Speed', value: 'travel_speed', align: 'center' },
      ]
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  watch: {
    dataTableOptions: {
      handler (value) {
        if (this.isGenerated) {
          this.getLiveStatus()
        }
      },
      deep: true,
    },
  },
  methods: {
    getLiveStatus () {
      this.$axios.post('getMachineStatus', { dataTableConfig: this.dataTableOptions, dataTableFilter: this.dataTableFilter }).then((res) => {
        const data = res.data
        if (data.data.length > 0) {
          this.totalTableDataCount = data.total_count
          this.report = data.data
          if (!this.startRequest) {
            this.startRequest = true
            this.interval = setInterval(() => {
              this.getLiveStatus()
            }, 10000)
          }
        } else {
          this.startRequest = false
        }
      }).catch((err) => {
        this.loading = false
        if (err.response.status === 422) {
          this.error = err.response.data.error_data
        } else {
          this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
        }
      })
    },
    generate () {
      this.isGenerated = true
      this.error = {}
      this.getLiveStatus()
    },
    exportData () {
      this.$axios.post('getMachineStatus', { dataTableConfig: this.dataTableOptions, dataTableFilter: this.dataTableFilter, isExport: true }).then((res) => {
        if (Object.prototype.hasOwnProperty.call(res.data, 'redirect') && Object.prototype.hasOwnProperty.call(res.data.redirect, 'file')) {
          this.downloadFile({
            fileUrl: 'downloadFile/' + res.data.redirect.file,
            name: res.data.redirect.file
          })
        } else {
          this.$eventBus.$emit('$globalSnackbar', 'red', 'Some error in export')
        }
      }).catch((err) => {
        this.loading = false
        if (err.response.status === 422) {
          this.error = err.response.data.error_data
        } else {
          this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
        }
      })
    },
    downloadFile (config = {}) {
      if (config.fileUrl) {
        this.$axios.get(config.fileUrl, { responseType: 'blob' }).then((res) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([res.data]))
          link.setAttribute('download', config.name)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$eventBus.$emit('$globalSnackbar', 'success', 'exported successfully!!')
        }).catch((err) => {
          console.log(err)
          this.$eventBus.$emit('$globalSnackbar', 'red', 'Some error in export')
        })
      }
    }
  }
}
</script>
<style>
</style>
